<template>
  <v-data-table
    :headers="$vuetify.breakpoint.width >= 991 ? headersExigencias[idioma][0] : headersExigencias[idioma][1]"
    :items="arrayTable"
    hide-actions
    item-key="id"
    select-all
    class="elevation-1 table-exigencias"
  >
    <template v-slot:headers="props">
      <tr>
        <th v-if="!apenasCalcula">
          <v-checkbox
            :input-value="selected"
            :indeterminate="indetermined"
            :disabled="editarExigencias || disabled "
            color="primary"
            hide-details
            @click.stop="!editarExigencias && !disabled ? toggleAll(exigencias, exigencias_selecionadas): selected = false"
          />
        </th>
        <th
          v-for="(header) in props.headers"
          :key="header.text"
          :style="textAlignHeader(header, headersExigencias[idioma])"
        >
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr
        v-for="(exigencia, name) in exigencias"
        v-if="!exigencia.apenasCalcula"
        :key="exigencia.id"
        :active="!apenasCalcula && exigencia.selecionado"
        :style="!apenasCalcula && exigencia.selecionado ? 'background-color: #0E3AFF; color: #fff; font-weight: 300' : ''"
        :class="exigencia.divider ? 'divider-exigencia' : ''">
        <td v-if="!apenasCalcula">
          <v-checkbox
            v-if="!exigencia.radio"
            :input-value="exigencia.selecionado"
            :disabled="editarExigencias || disabled"
            :color="!apenasCalcula && exigencia.selecionado ? 'white' : 'primary'"
            hide-details
            @click.stop="!apenasCalcula && !editarExigencias && !disabled && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null"
          />
          <v-radio-group
            v-else
            v-model="exigencia.selecionado"
            :disabled="editarExigencias || disabled"

            hide-details
            row
            @click.stop="!apenasCalcula? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null">
            <v-radio
              :disabled="editarExigencias || disabled"
              :value="true"
              :color="!apenasCalcula && exigencia.selecionado ? 'white' : 'primary'"
            />
          </v-radio-group>
        </td>
        <td
          v-if="$vuetify.breakpoint.width >= 991 && props.item.id === 'ok'"
          :style="(apenasCalcula)?'min-width: 500px; padding-top:0; padding-bottom:0':''">
          <v-layout
            align-center
            justify-start
            row
            fill-height>
            <strong
              v-if="(!apenasCalcula && exigencia.childs) || !exigencia.childs"
              @click="!apenasCalcula && !editarExigencias && !exigencia.disabled && !disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null">{{ exigencia.changed ? '*' : '' }}{{ exigencia.exigencia[idioma] }}</strong>
            <v-menu
              v-if="exigencia.childs"
              :close-on-content-click = "false"
              bottom
              attach
              offset-y
              transition="slide-x-transition"
            >

              <template v-slot:activator = "{ on }" >
                <strong
                  v-if="apenasCalcula"
                  @click="$refs['menu_' + name][0].$el.click()">{{ exigencia.changed ? '*' : '' }}{{ exigencia.exigencia[idioma] }}</strong>
                <v-btn
                  :color="(exigencia.selecionado) ? 'white' : 'black'"
                  :ref="'menu_' + name"
                  flat
                  icon
                  v-on="on">
                  <v-icon>{{ 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </template>

              <v-card
                v-slot:default
                style="min-width: 500px; max-height: 300px; overflow: auto;"
              >
                <v-layout
                  pa-2
                  align-center
                  row
                  class = "elevation-3 white--text"
                  style = "background-color:#5c4848">

                  <v-flex
                    pa-2
                    xs4>
                    <strong>{{ strings[idioma].exigencia_complementar }}</strong>
                  </v-flex>
                  <v-flex
                    pa-2
                    xs2>
                    <strong>{{ strings[idioma].unidade_exigencia }}</strong>
                  </v-flex>
                  <v-flex
                    pa-2
                    xs2>
                    <strong>{{ strings[idioma].minimo_exigencia }}</strong>
                  </v-flex>
                  <v-flex
                    pa-2
                    xs2>
                    <strong>{{ strings[idioma].ideal_exigencia }}</strong>
                  </v-flex>
                  <v-flex
                    pa-2
                    xs2>
                    <strong>{{ strings[idioma].maximo_exigencia }}</strong>
                  </v-flex>
                </v-layout>
                <template>
                  <v-layout
                    v-for = "(item,index) in exigencia.childs"
                    :key = "index"
                    align-center
                    row
                    class = "elevation-1">
                    <template
                      v-if="((!item.lactante) || (item.lactante && (animal.estado_fisiologico.valor === 'lactante' || animal.estado_fisiologico.valor === 'gestante_lactante')))">

                      <v-flex
                        pa-2
                        xs4
                        style="font-size: small">
                        {{ item.name[idioma] }} <small>({{ item.codigo[idioma] }})</small>
                      </v-flex>

                      <v-flex
                        pa-2
                        xs2
                        style="font-size: small">
                        {{ item.unidade[idioma] }}
                      </v-flex>

                      <v-flex
                        pa-2
                        xs2
                        align-center>
                        <v-text-field
                          v-money="optionsNumber.float2[idioma]"
                          v-if="item.minimo !== '-' && parseString(item.minimo, idioma) !== 0"
                          v-model="item.minimo"
                          class="text-field-table"
                          color="primary"
                          readonly
                          outline

                        />
                        <input
                          v-else
                          value="-"
                          readonly
                          class="text-field-table input-form-exigencia-complementar"
                          color="primary"
                        >
                      </v-flex>
                      <v-flex
                        pa-2
                        xs2>
                        <v-text-field
                          v-money="optionsNumber.float2[idioma]"
                          v-if="item.ideal !== '-' && parseString(item.ideal, idioma) !== 0"
                          v-model.lazy="item.ideal"
                          class="text-field-table"
                          color="primary"
                          readonly
                          outline
                        />
                        <input
                          v-else
                          value="-"
                          readonly
                          class="text-field-table input-form-exigencia-complementar"
                          color="primary"
                        >

                      </v-flex>
                      <v-flex
                        pa-2
                        xs2>
                        <v-text-field
                          v-money="optionsNumber.float2[idioma]"
                          v-if="item.maximo !== '-' && parseString(item.maximo, idioma) !== 0"
                          v-model.lazy="item.maximo"
                          class="text-field-table"
                          color="primary"
                          readonly
                          outline

                        />
                        <input
                          v-else
                          value="-"
                          readonly
                          class="text-field-table input-form-exigencia-complementar"
                          color="primary"
                        >

                      </v-flex>
                    </template>
                  </v-layout>
                </template>
              </v-card>

            </v-menu>
          </v-layout>
        </td>
        <td
          v-if="$vuetify.breakpoint.width >= 991"
          style="padding-right: 40px"
          @click="!apenasCalcula && !editarExigencias && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null"><strong>{{ exigencia.codigo[idioma] }}</strong></td>
        <td
          v-if="$vuetify.breakpoint.width >= 991"
          @click="!apenasCalcula && !editarExigencias && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null"><strong>{{ exigencia.unidade[idioma] }}</strong></td>
        <td v-else>
          <v-layout column>
            <strong>{{ exigencia.codigo[idioma] }}</strong>
            ({{ exigencia.unidade[idioma] }})
          </v-layout>
        </td>
        <td @click="!apenasCalcula && !editarExigencias && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null">
          <v-text-field
            v-if="exigencia.minimo !== '-' && !changeMinMax && exigencia.minEditable && (editarExigencias && !disabled)"
            v-model="exigencia.minimo"
            class="text-field-table input-form-exigencia-complementar input-editavel"
            color="primary"
            outline
            pattern="\d*"
            inputmode="decimal"
            @change="changeMinExigencias(name);"
          />

          <input
            v-else-if="(exigencia.minimo === '-' || parseString(exigencia.minimo, idioma) === '0') && !changeMinMax && exigencia.minEditable && (editarExigencias && !disabled)"
            v-model.lazy="exigencia.minimo"
            class="input-form-exigencia-complementar"
            pattern="\d*"
            inputmode="decimal"
            @change="changeMinExigencias(name)"
          >

          <input
            v-money="optionsNumber.float2[idioma]"
            v-else-if="exigencia.minimo !== '-' && exigencia.minimo !== null && parseString(exigencia.minimo, idioma) !== 0 && !changeMinMax"
            v-model.lazy="exigencia.minimo"
            color = "black"
            readonly
            class="input-form-exigencia"
          >
          <input
            v-else
            value="-"
            readonly
            class="input-form-exigencia"
          >

        </td>
        <td @click="!apenasCalcula && !editarExigencias && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null">
          <v-text-field

            v-if="(!(block && !exigencia.changed) && (exigencia.ideal !== '-' && exigencia.idealEditable && (editarExigencias && !disabled)) && (exigencia.id === 'PNDR' || exigencia.id === 'PDR' || exigencia.id === 'PB'))"
            v-model.lazy="exigencia.ideal"
            class="text-field-table input-editavel"
            color="primary"
            outline
            pattern="\d*"
            inputmode="decimal"
            @paste="(evt) => $validateOnlyNumbers(evt, true, idioma)"

            @keypress="val => onlyFloat(val, exigencia, 'ideal')"
            @change="limpezaDeDados(exigencia, 'ideal'); changeMinMaxExigencias(name)"
          />
          <v-text-field
            v-money="optionsNumber.float2[idioma]"

            v-else-if="((exigencia.ideal !== '-' && exigencia.idealEditable && (editarExigencias && !disabled)) && (exigencia.id === 'PNDR' || exigencia.id === 'PDR' || exigencia.id === 'PB'))"
            v-model.lazy="exigencia.ideal"
            readonly
            class="text-field-table"
            @paste="(evt) => $validateOnlyNumbers(evt, true, idioma)"

            @keypress="val => onlyFloat(val, exigencia, 'ideal')"
            @change="$limpezaDeDados(exigencia, 'ideal'); changeMinMaxExigencias(name)"
          />
          <v-text-field
            v-else-if="((exigencia.ideal !== '-' && exigencia.idealEditable && (editarExigencias && !disabled)))"
            v-model.lazy="exigencia.ideal"
            class="text-field-table input-editavel"
            color="primary"
            outline
            pattern="\d*"
            inputmode="decimal"
            @paste="(evt) => $validateOnlyNumbers(evt, true, idioma)"

            @keypress="val => onlyFloat(val, exigencia, 'ideal')"
            @change="limpezaDeDados(exigencia, 'ideal'); changeMinMaxExigencias(name)"
          />
          <v-text-field
            v-else-if="((exigencia.id === 'PNDR' || exigencia.id === 'PDR' || exigencia.id === 'PB') && (((exigencias['PB'].changed?1:0) + (exigencias['PDR'].changed?1:0) + (exigencias['PNDR'].changed?1:0)) < 2) && (exigencia.ideal !== '-' && exigencia.idealEditable && (editarExigencias && !disabled)))"
            v-model="exigencia.ideal"
            class="text-field-table input-editavel"
            color="primary"
            outline
            pattern="\d*"
            inputmode="decimal"
            @paste="(evt) => $validateOnlyNumbers(evt, true, idioma)"

            @keypress="val => onlyFloat(val, exigencia, 'ideal')"
            @change="limpezaDeDados(exigencia, 'ideal'); changeMinMaxExigencias(name)"
          />
          <input
            v-else-if="exigencia.ideal === '-' && exigencia.idealEditable && (editarExigencias && !disabled)"
            v-model.lazy="exigencia.ideal"
            class="input-form-exigencia-complementar"
            pattern="\d*"
            inputmode="decimal"
            @click="exigencia.ideal = 0"
            @paste="(evt) => $validateOnlyNumbers(evt, true, idioma)"

            @keypress="val => onlyFloat(val, exigencia, 'ideal')"
            @change="limpezaDeDados(exigencia, 'ideal'); changeMinMaxExigencias(name)"
          >
          <input
            v-money="optionsNumber.float2[idioma]"
            v-else-if="exigencia.ideal !== '-' && parseString(exigencia.ideal, idioma) !== 0"
            v-model.lazy="exigencia.ideal"
            readonly
            class="input-form-exigencia"
          >
          <input
            v-else
            value="-"
            readonly
            class="input-form-exigencia"
          >
        </td>
        <td @click="!apenasCalcula && !editarExigencias && !exigencia.disabled ? changeSelectExigencia(exigencia, exigencias, exigencias_selecionadas, name) : null">

          <v-text-field
            v-money="optionsNumber.float2[idioma]"
            v-if="exigencia.maximo !== '-' && !changeMinMax && exigencia.maxEditable && (editarExigencias && !disabled)"
            v-model.lazy="exigencia.maximo"
            class="text-field-table input-editavel"
            color="primary"
            pattern="\d*"
            inputmode="decimal"
            outline
            @change="changeMaxExigencias(name)"
          />
          <input
            v-else-if="exigencia.maximo === '-' && !changeMinMax && exigencia.maxEditable && editarExigencias"
            v-model.lazy="exigencia.maximo"
            class="input-form-exigencia-complementar"
            pattern="\d*"
            inputmode="decimal"
            @change="changeMaxExigencias(name)"
          >
          <input
            v-money="optionsNumber.float2[idioma]"
            v-else-if="exigencia.maximo !== '-' && parseString(exigencia.maximo, idioma) !== 0"
            v-model.lazy="exigencia.maximo"
            readonly
            class="input-form-exigencia"
          >
          <input
            v-else
            value="-"
            readonly
            class="input-form-exigencia"
          >
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    arrayTable: {
      type: Array,
      default: () => [
        {
          id: 'ok'
        }
      ]
    },
    editarExigencias: {
      type: Boolean,
      default: () => false
    },
    apenasCalcula: {
      type: Boolean,
      default: () => false
    },
    selected: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    changeMinMax: false,
    recalculandoExigencias: false,
    indetermined: false,
    block: false
  }),
  watch: {
    editarExigencias (val) {
      if (val) {
        var i = 0
        for (let ex of ['PNDR', 'PDR', 'PB']) {
          if (this.exigencias[ex].changed) i++
        }
        this.block = i === 2
      }
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'optionsNumber', 'animal', 'exigencias', 'exigencias_selecionadas', 'alimentos_selecionados', 'headersExigencias']),
    blocked () {
      let i = 0
      for (let ex of ['PNDR', 'PDR', 'PB']) {
        if (this.exigencias[ex].changed) i++
      }
      return i === 2
    }
  },
  mounted () {
    this.editarExigencias = this.disabled
  },
  methods: {
    exigenciaClick (exigencia, name = '') {
      console.log(this.apenasCalcula)
      if (!this.apenasCalcula && !this.editarExigencias && !exigencia.disabled) {
        this.changeSelectExigencia(exigencia, this.exigencias, this.exigencias_selecionadas, name)
      } else if (this.apenasCalcula) {
        if (!this.menuExigencias[name]) {
          this.$refs['ex_menu_' + name][0].$el.click()
        }
        this.menuExigencias[name] = !this.menuExigencias[name]
      } else {
        this.changeSelectExigencia(exigencia, this.exigencias, this.exigencias_selecionadas, name)
      }
    },
    limpezaDeDados (input, tipo, casas = 2) {
      if (input[tipo] === null) return
      input[tipo] = this.parseString(input[tipo], this.idioma).toFixed(casas).replace('.', this.strings[this.idioma].separador_float)
    },
    onlyFloat (val, input, tipo) {
      this.$onlyFloat(val, input, tipo, this.idioma)
    },
    parseString (valor, idioma) {
      return this.$parseString(valor, idioma)
    },
    changeMinMaxExigencias (name) {
      if (!this.exigencias_selecionadas.has(name)) {
        let msg = this.strings[this.idioma].atencao_exigencia
        let time = 6000
        this.$store.commit('openErrorAlert', {
          msg,
          time
        })
      }
      var i = 0
      for (let ex of ['PNDR', 'PDR', 'PB']) {
        if (this.exigencias[ex].changed) i++
      }
      this.block = (['PNDR', 'PDR', 'PB'].includes(name)) ? (i >= 1) : (i >= 2)
      this.$emit('changeMinMaxExigencias', { name, block: this.block })
    },
    changeMinExigencias (name) {
      this.changeMinMax = true
      this.$store.commit('setMinExigencias', name)
      this.$nextTick(() => {
        this.changeMinMax = false
      })
    },
    changeMaxExigencias (name) {
      this.changeMinMax = true
      this.$store.commit('setMaxExigencias', name)
      this.$nextTick(() => {
        this.changeMinMax = false
      })
    },
    changeSelectExigencia (exigencia, exigencias, selecionadas, name) {
      this.$store.commit('setDietaCalculada', false)
      if (this.editarExigencias) return
      /* if (name === 'PNDR' || name === 'PDR' || name === 'PB') {
        let cont = 0
        selecionadas.forEach((ex) => { if (ex === 'PNDR' || ex === 'PDR' || ex === 'PB') cont += 1 })
        if (cont > 1) {
          exigencia.selecionado = false
          exigencias[name].selecionado = false
          selecionadas.delete(name)
          return
        } else {
          if (exigencia.radio) {
            exigencia.selecionado = true
            exigencia.otherOptions.forEach(el => {
              exigencias[el].selecionado = false
              selecionadas.delete(el)
            })
            selecionadas.add(name)
            if (selecionadas.size === 20) {
              this.selected = true
              this.indetermined = false
            } else {
              this.indetermined = true
              this.selected = false
            }
          }
        }
      } */
      this.$emit('changeSelectExigencia', { exigencia, exigencias, selecionadas, name })
      /* if (!exigencia.radio) {
        exigencia.selecionado = !exigencia.selecionado
        if (exigencia.selecionado) {
          selecionadas.add(name)
          if (selecionadas.size === 20) {
            this.selected = true
            this.indetermined = false
          } else {
            this.indetermined = true
            this.selected = false
          }
        } else {
          selecionadas.delete(name)
          if (selecionadas.size === 1) {
            this.selected = false
            this.indetermined = false
          } else {
            this.indetermined = true
            this.selected = false
          }
        }
      } else {
        exigencia.selecionado = true
        exigencia.otherOptions.forEach(el => {
          exigencias[el].selecionado = false
          selecionadas.delete(el)
        })
        selecionadas.add(name)
        if (selecionadas.size === 20) {
          this.selected = true
          this.indetermined = false
        } else {
          this.indetermined = true
          this.selected = false
        }
      } */

      /* if (name === 'PNDR' || name === 'PDR' || name === 'PB') {
        let cont = 0
        selecionadas.forEach((ex) => { if (ex === 'PNDR' || ex === 'PDR' || ex === 'PB') cont += 1 })
        if (cont > 2) {
          exigencia.selecionado = false
          exigencias[name].selecionado = false
          selecionadas.delete(name)
          return
        }
      } */
      this.$nextTick(() => {
        if (selecionadas.size >= 2) { this.$emit('stepComplete1', {}) } else { this.$emit('stepIncomplete1', {}) }
        this.indetermined = selecionadas.size >= 2
        this.selected = selecionadas.size >= 20
      })
    },
    renderMask (esq, dir, idioma) {
      return {
        decimal: !idioma ? ',' : '.',
        thousands: !idioma ? '.' : ',',
        precision: 2,
        prefix: (esq && esq[idioma] !== undefined) ? esq[idioma] + ' ' : ' ',
        suffix: (dir && dir[idioma] !== undefined) ? ' ' + dir[idioma] : ' '
      }
    },
    textAlignHeader (header, headers) {
      if (this.$vuetify.breakpoint.width >= 991) {
        if (header.text !== headers[0][3].text && header.text !== headers[0][4].text && header.text !== headers[0][5].text) return 'text-align: left; font-size: 16px'
        else return 'text-align: center; font-size: 16px'
      } else {
        if (header.text !== headers[1][1].text && header.text !== headers[1][2].text && header.text !== headers[1][3].text) return 'text-align: left; font-size: 16px'
        else return 'text-align: center; font-size: 16px'
      }
    },
    toggleAll (exigencias, selecionadas) {
      this.$store.commit('setDietaCalculada', false)

      this.$emit('toggleAll', { exigencias, selecionadas })
    }
  }
}
</script>
